import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useSession } from "../lib/session";

/**
 * The frame for screens a member reaches after signing in but before
 * opening a society — the welcome screen, and joining or starting one.
 *
 * Same navy bar as inside the app, but it carries the PostcardGolf brand
 * rather than a society's name. Opening a society then reads as the bar
 * changing hands, not as a different app appearing.
 */
export default function BrandShell({ children }) {
  const { profile } = useSession();
  const initials = (profile?.full_name ?? "?")
    .split(/\s+/).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

  return (
    <div className="brand-shell">
      <header className="brand-bar">
        <Logo size={26} ink="#fff" wordSize="1.1rem" />
        {profile && (
          <>
            <span className="spacer" />
            <Link to="/account" className="avatar" aria-label="Your account">{initials}</Link>
          </>
        )}
      </header>
      <main className="brand-main">
        <div className="centre-box">{children}</div>
      </main>
    </div>
  );
}
